export enum RpmAssessmentType {
  RPM_QUESTIONNAIRE_EVENT = 'RPM_QUESTIONNAIRE_EVENT',
  RPM_DEVICE_EVENT = 'RPM_DEVICE_EVENT',
}

export const RPM_ASSESSMENT_TYPES = [
  RpmAssessmentType.RPM_QUESTIONNAIRE_EVENT,
  RpmAssessmentType.RPM_DEVICE_EVENT,
] as const;
